/**
 * Leprendo Klaviyo Module
 * Handles newsletter signup form submissions to Klaviyo's subscribe API.
 */

(function () {
  'use strict';

  async function submitToKlaviyo(email, listId) {
    if (!listId) throw new Error('No Klaviyo list ID configured.');
    const url = `https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(listId)}`;
    const payload = {
      data: {
        type: 'subscription',
        attributes: {
          list_id: listId,
          email: email
        }
      }
    };
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2023-02-22' },
      body: JSON.stringify(payload)
    });
    if (!res.ok && res.status !== 202) {
      throw new Error('Subscription failed. Please try again.');
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-klaviyo-form]').forEach(form => {
      const listId = form.dataset.listId || window.Leprendo?.klaviyoListId;
      const input = form.querySelector('input[type="email"]');
      const btn = form.querySelector('button[type="submit"]');
      const successMsg = form.querySelector('[data-success-msg]');
      const errorMsg = form.querySelector('[data-error-msg]');

      form.addEventListener('submit', async e => {
        e.preventDefault();
        if (!input?.value) return;

        const email = input.value.trim();
        const original = btn?.innerHTML;
        if (btn) { btn.disabled = true; btn.textContent = 'Subscribing...'; }
        if (errorMsg) errorMsg.style.display = 'none';

        try {
          await submitToKlaviyo(email, listId);
          if (successMsg) { successMsg.style.display = ''; form.querySelector('.klaviyo-fields')?.remove(); }
          input.value = '';
        } catch (err) {
          if (errorMsg) { errorMsg.textContent = err.message; errorMsg.style.display = ''; }
        } finally {
          if (btn) { btn.disabled = false; btn.innerHTML = original; }
        }
      });
    });
  });
})();
